import Vue from 'vue';
import { createNamespacedHelpers, mapState } from 'vuex';
import VueChatScroll from 'vue-chat-scroll';
import ChatDefs from '@/store/chat/chat.d';
import MessageItem from '@/components/message_item/MessageItem.vue';

const { mapActions: mapChatActions } = createNamespacedHelpers('Chat');

Vue.use(VueChatScroll);

export default {
  name: 'MessageList',
  components: { MessageItem },

  unmounted: function() {
    this.leaveChannel();
    this.unregisterChatListener();
  },

  methods: {
    ...mapChatActions({
      enterChannel: ChatDefs.actions.enterChannel,
      leaveChannel: ChatDefs.actions.leaveChannel,
      loadInitialMessages: ChatDefs.actions.loadInitialMessages,
      loadOlderMessages: ChatDefs.actions.loadOlderMessages,
      registerChatListener: ChatDefs.actions.registerChatListener,
      unregisterChatListener: ChatDefs.actions.unregisterChatListener
    }),

    /**
     * Used to determine the scroll position
     * If the position at the top, then try load more messages
     */
    onScroll: async function() {
      if (this.isLoadingOlderMessage || !this.canLoadMoreMessage) return;

      // Only continue if the scroll position at the top
      const scrollValue = this.$refs.chatContainer.scrollTop;
      if (scrollValue > 5) return;

      const { scrollHeight: oldHeight } = this.$refs.chatContainer;
      this.isLoadingOlderMessage = true;

      const canLoadMore = await this.loadOlderMessages();
      this.canLoadMoreMessage = canLoadMore;

      // Maintain scroll position after new messages is prepended
      const { scrollHeight: currentHeight } = this.$refs.chatContainer;
      const diffHeight = currentHeight - oldHeight;
      this.$refs.chatContainer.scrollTop = diffHeight;

      this.isLoadingOlderMessage = false;
    },

    /**
     * Load first message and reigster the chat listeners
     */
    loadMessages: async function() {
      this.isLoadingOlderMessage = false;
      this.canLoadMoreMessage = true;

      await this.loadInitialMessages();
      this.registerChatListener();

      // Set the current viewport to the recent message
      const { scrollHeight } = this.$refs.chatContainer;
      this.$refs.chatContainer.scrollTop = scrollHeight;
    }
  },

  data: () => ({
    isLoadingOlderMessage: false,
    canLoadMoreMessage: true
  }),

  computed: mapState({
    currentChannel: state => state.Channel.currentChannel,
    messages: state => state.Chat.messages
  }),

  watch: {
    currentChannel: {
      handler: 'loadMessages',
      immediate: true
    }
  }
};
